<template>
    <div>
        <v-row>
            <v-col sm="2">
                <v-label>
                    {{ $t('indicators.indicators_wizard.body.title') }} :
                </v-label>
            </v-col>
            <v-col>
                Indicadores_2021-2022
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="2">
                <v-label>
                    {{ $t('indicators.indicators_wizard.body.academic_period') }} :
                </v-label>
            </v-col>
            <v-col>
                2021-2022
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="2">
                <v-label>
                    {{ $t('indicators.indicators_wizard.body.data_origin') }} :
                </v-label>
            </v-col>
            <v-col>
                Biblia 2021 <v-label>(Biblia)</v-label>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="2"></v-col>
            <v-col>
                Encuesta 2021 <v-label>(Encuesta)</v-label>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="2"></v-col>
            <v-col>
                Indicador abandono 2021 <v-label>(Indicador de abandono)</v-label>
            </v-col>
        </v-row>
        <v-row>
            <v-col sm="2">
                <v-label>
                    {{ $t('indicators.indicators_wizard.body.template') }} :
                </v-label>
            </v-col>
            <v-col>
                <v-btn
                        class='btn-icon--primary btn-icon'                        
                    ><v-icon>mdi-eye</v-icon>
                </v-btn>
            </v-col>
        </v-row>
    </div>
</template>
<script>
export default {
    name: "IndicatorWizardStep1",

    data() {
        return {
            indicatorWizardStep: 1,
        }
    },

    methods: {
    },
}
</script>

<style scoped>

</style>